import React, { useContext } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { ThemeContext } from 'styled-components'
import { useTranslation } from 'react-i18next'

// ui-kit
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'
import { Row, Col } from '@navent-jobs/ui-kit/components/grid'
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import Text from '@navent-jobs/ui-kit/components/text'

// components
import Skills from '../../Skills'
import Legales from '../../Legales'
import DetalleAviso from './components/DetalleAviso'
import DetalleDescripcion from './components/DetalleDescripcion'

// mixins
import { DescripcionAviso, SeparadorDetalle, HeaderContainer } from './mixins'
import ProductBanner from '../../../../product-banner'
import { IS_ZONA_JOBS } from '../../../../../constants'

const Component = ({ aviso, productBannersFeature, urlMaker, postulacionRapida = false }) => {
  const { colors } = useContext<{ colors }>(ThemeContext)
  const { isMobile, isTabletPortrait } = useWindowSize()
  const isMobileOrTabletPortrait = isMobile || isTabletPortrait
  const { t } = useTranslation()

  return (
    <Row>
      <Col>
        <DescripcionAviso>
          <DetalleDescripcion aviso={aviso} urlMaker={urlMaker} postulacionRapida={postulacionRapida} />
          {/* El encabezado puede ser texto libre */}
          {aviso?.encabezado && (
            <Text size="md" variant="gray84">
              {ReactHtmlParser(aviso.encabezado)}
            </Text>
          )}
          <HeaderContainer>
            <Icon name="icon-light-file-text" color={colors.secondary.normal} size="20" />
            <Text size="lg" as="h3" fontWeight="semibold" variant="secondary">
              {t('fichaAviso.descripcion.titulo')}
            </Text>
          </HeaderContainer>
          <Text size="md" variant="gray84">
            {ReactHtmlParser(aviso.descripcionSimple)}
          </Text>
          {aviso?.beneficios && (
            <>
              <HeaderContainer>
                <Icon name="icon-light-heart" color={colors.secondary.normal} size="20" />
                <Text size="lg" as="h3" fontWeight="semibold" variant="secondary">
                  {t('fichaAviso.descripcion.beneficios')}
                </Text>
              </HeaderContainer>
              <Text size="md" variant="gray84">
                {ReactHtmlParser(aviso.beneficios)}
              </Text>
            </>
          )}
          <SeparadorDetalle />
          <DetalleAviso aviso={aviso} urlMaker={urlMaker} />
        </DescripcionAviso>

        {aviso.requisitos && aviso.requisitos.conocimientos && (
          <Skills conocimientos={aviso.requisitos.conocimientos} />
        )}

        {isMobileOrTabletPortrait && <Legales />}

        {!IS_ZONA_JOBS && productBannersFeature && <ProductBanner colSizeXl={9} verticalSize="sm" />}
      </Col>
    </Row>
  )
}

export default Component
